import useStyles from "./styles";

const ButtonBlue = ({ label, isPulse, onClick }) => {
    const classes = useStyles();
    if (isPulse) {
        return (
            <button className={`${classes.button} ${classes.buttonPulse}`} onClick={onClick}>
                <span>{label}</span>
            </button>
        );
    }
    return (
        <button className={classes.button} onClick={onClick}>
            <span>{label}</span>
        </button>
    );
};

export default ButtonBlue;